var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("img", {
    staticClass: "w-24 h-24 mt-8 icon inline-block mb-1",
    attrs: { src: _vm.src, alt: _vm.alt },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }